import styled from 'styled-components';
import { Typography } from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

const tertiaryMain = getThemeByPath('colors.tertiary.main');

const radiusMedium = getThemeByPath('radius.medium');

const spacingSmall = getThemeByPath('spacings.small');

export const BubbleWrapper = styled.div`
  padding: ${spacingSmall}px;
  background-color: ${tertiaryMain};
  border-radius: 0 ${radiusMedium}px ${radiusMedium}px ${radiusMedium}px;
`;

export const BubbleText = styled(Typography).attrs({
  variant: 'headline6',
  textColor: 'colors.text.main',
  typographyProps: {
    style: {
      textAlign: 'left',
      fontWeight: 'normal',
    },
  },
})``;
